import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { changeUserRole, getUserRole } from "../actions/user.actions";
import HorizontalForm from "./components/UserRoleForm";

const UserRoleForm = (props) => {
    const { dispatch, user } = props;

    function fetchUser() {
        dispatch(getUserRole(props.match.params.id));
    }

    const addUser = (values) => {
        
        dispatch(changeUserRole(values, props.match.params.id, user.response));
    };

    useEffect(() => {
        if (props.match.params.id) {
            dispatch(getUserRole(props.match.params.id));
        }
    }, [dispatch, props.match.params.id]);

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Manage User's Role</h3>
                </Col>
            </Row>
            <Row>
                <HorizontalForm userId={props.match.params.id} user={user} fetchData={fetchUser} onSubmit={addUser} />
            </Row>
        </Container>
    );
};

export default connect((state) => ({
    user: state.getuserrole,
}))(UserRoleForm);
